export class AssetDepTotal {
    count: number;
    valueInv: number;
    valueRem: number;
    valueDep: number;
    valueDepYTD: number;
    valueDepPu: number;
    valueInitial: number;
}